import React from 'react';
import { Box, Alert, Button, Typography } from '@mui/material';
import { ExitToApp as ExitIcon } from '@mui/icons-material';
import { useImpersonation } from '../contexts/ImpersonationContext';

export const ImpersonationBanner: React.FC = () => {
  const { impersonationState, exitImpersonation } = useImpersonation();

  if (!impersonationState.isImpersonating || !impersonationState.impersonatedUser) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        top: '64px', // Position below navbar (navbar is 64px/h-16)
        zIndex: 1000, // Below navbar (z-50 = 50, but MUI uses higher numbers) but above content
        width: '100%',
        pointerEvents: 'none' // Allow clicks to pass through to navbar
      }}
    >
      <Alert
        severity="warning"
        action={
          <Button
            color="inherit"
            size="small"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              console.log('🚪 Exit Impersonation button clicked');
              exitImpersonation();
            }}
            startIcon={<ExitIcon sx={{ color: '#ed6c02' }} />}
            sx={{ 
              fontWeight: 'bold', 
              pointerEvents: 'auto',
              whiteSpace: 'nowrap',
              flexShrink: 0
            }}
          >
            Exit Impersonation
          </Button>
        }
        sx={{
          borderRadius: 0,
          pointerEvents: 'auto', // Allow clicks on the alert itself
          display: 'flex',
          alignItems: 'center', // Center align all content vertically
          '& .MuiAlert-icon': {
            display: 'none' // Hide the default Alert icon
          },
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            alignItems: 'center', // Center align message content
            justifyContent: 'space-between'
          },
          '& .MuiAlert-action': {
            display: 'flex',
            alignItems: 'center' // Center align action content
          }
        }}
      >
        <Typography 
          variant="body2" 
          component="span"
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            lineHeight: '1.5'
          }}
        >
          <strong>Viewing as: </strong>{impersonationState.impersonatedUser.name || impersonationState.impersonatedUser.email || 'Unknown User'}
        </Typography>
      </Alert>
    </Box>
  );
};









